import { render, staticRenderFns } from "./campaigns-filter-select.vue?vue&type=template&id=2be3ba1a&"
import script from "./campaigns-filter-select.vue?vue&type=script&lang=js&"
export * from "./campaigns-filter-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports